import React from "react";
import {  STATUS } from "../../../../constants";
import { Box, Tooltip } from "@material-ui/core";
import { useStyles } from "../styles";

const TargetDueDate = ({status, dateType, dateString}) => {
  const classes = useStyles();
  return (
    <td
      className={
        status === STATUS["OVERDUE"] && dateType === "dueDate" ? classes.errorMsg : ""
      }>
      <Box display={"flex"} alignItems="center" justifyContent="center">
        <Tooltip
          title={dateString}>
          <span className="truncate-txt">
            {dateString}
          </span>
        </Tooltip>
      </Box>
    </td>
  );
};

export default TargetDueDate;
